import { HttpClient } from '@core/httpClient';
import { END_POINTS } from '@services/urls';

import { buildPathWithParams } from '@utils/urls';

import { TPaymentRequestData, TPaymentResponseData, TSupportProfileDetails } from './types';

export class AstroPayProService {
  public static getStoreDetails = async (storeTag: string): Promise<TSupportProfileDetails> => {
    try {
      const response = await HttpClient.GET<TSupportProfileDetails>({
        url: buildPathWithParams(END_POINTS.storeDetails, { storeTag }),
        useQueryParams: false,
      });

      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  public static createPayment = async (
    paymentRequestData: TPaymentRequestData,
  ): Promise<TPaymentResponseData> => {
    try {
      const dataPayload = {
        app_id: paymentRequestData.appId,
        environment: import.meta.env.VITE_ENV,
      };

      const encoded = btoa(unescape(JSON.stringify(dataPayload)));
      HttpClient.setAppDataRequest(encoded);

      const response = await HttpClient.POST<TPaymentResponseData>({
        url: END_POINTS.createPayment,
        data: paymentRequestData,
        useQueryParams: true,
      });

      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  };
}
